export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7435.2e8e1dda.jpg";